import { DeliveryProviderKeys, DeliveryProviders } from "../Enums/DeliveryProviders";

export interface Delivery {id: DeliveryProviders, key: DeliveryProviderKeys };